import { render, staticRenderFns } from "./CreateClientView.vue?vue&type=template&id=93680a1e"
import script from "./CreateClientView.vue?vue&type=script&lang=js"
export * from "./CreateClientView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports